import { apiDefinition } from './definitions';

class GlabalAuthData {
  public get accessToken(): string {
    return apiDefinition.accessToken;
  }

  public get xImpersonateOrg(): string {
    return apiDefinition.xImpersonateOrg;
  }

  public setAccessToken(acessToken: string): void {
    apiDefinition.setAccessToken(acessToken);
  }

  public setOrgId(orgId: string): void {
    apiDefinition.setOrgId(orgId);
  }

  public clearAccessToken(): void {
    apiDefinition.clearAccessToken();
  }

  public clearOrgId(): void {
    apiDefinition.clearOrgId();
  }
}

export default new GlabalAuthData();
